<script>
import MyHeader from "@/components/Header.vue";
import {mapMutations} from "vuex";
import {EventBus} from "@/main";
import {AppConfig} from "@/AppConfig";

export default {
  name: "OneLeaveMenuPage",
  components: {MyHeader},
  data() {
    return {
      checkInvitePermission: false,

      headerData: [],
      headerDataGuard: [
        {name: 'visitorRegister', label: '访客登记'},
        {name: 'visitorRecord', label: '访客记录'},
        {name: 'visitorApply', label: '邀约预约'},
        {name: 'GuardSetting', label: '保安设置'},
      ],
      headerDataEmployee: [
        {name: 'inviteVisitor', label: '邀请访客'},
        {name: 'inviteBatch', label: '批量邀请'},
        // {name: 'applyingRecord', label: '等待审批'},
        {name: 'appliedRecord', label: '邀约预约'},
        {name: 'historyRecord', label: '到访记录'},
        {name: 'usualInviteVisitor', label: '常邀访客'},
      ],
      headerIndex: 'localRegistration',
      dropData: [
        {command: 'exit', label: '退出登录'},
      ],
    }
  },
  methods: {
    ...mapMutations(['setLoginData', 'setPageInfo', 'setMyPermission', 'setMyApplyDepartmentIds', 'setMyArriveDepartmentIds', 'setEmployeeLoginData', "setRoleData", "doOnLogout"]),
    mainHeaderClick(index) {
      if (this.headerIndex !== index) {
        this.$router.push({name: index})
        this.headerIndex = index
      }
    },
    sysHeaderHeader(command) {
      console.log("page sysHeaderHeader", command)
      if (command === 'exit') {
        this.doOnLogout()
        this.$router.push({name: 'login'})
      } else {
        console.error("command not found", command)
      }
    },
  },
  mounted() {
    this.checkInvitePermission = AppConfig.checkInvitePermission

    let roleType = this.$store.state.roleType
    let accountType = this.$store.state.accountType
    console.log("@@@ roleType", roleType)
    if (accountType === 'employee') {
      if (this.checkInvitePermission && this.$store.state.employeeLoginInfo.inviteAuth !== "VALID") {
        this.headerData = [
          // {name: 'applyingRecord', label: '等待审批'},
          {name: 'appliedRecord', label: '邀约预约'},
          {name: 'historyRecord', label: '到访记录'},
        ]
      } else {
        this.headerData = this.headerDataEmployee
      }
      this.headerIndex = this.headerData[0].name
    } else if (accountType === 'manage') {
      if (roleType === 'GUARD') {
        this.headerData = this.headerDataGuard
        this.headerIndex = this.headerData[0].name
      } else {
        console.error("roleType not found", roleType)
      }
    } else {
      console.error("accountType not found", accountType)
    }


    EventBus.$on('GuideJump', (data) => {
      this.$nextTick(() => {
        this.headerIndex = data.index
        this.$router.push({name: data.name, params: data.params})
      })
    })

  }
}
</script>

<template>
  <div>
    <el-container>
      <el-header height="64px">
        <MyHeader :menu-data="headerData" :menu-index="headerIndex" :main-click="mainHeaderClick"
                  :sys-click="sysHeaderHeader" :drop-data="dropData"></MyHeader>
      </el-header>
      <el-main class="page-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<style scoped lang="less">

.el-container {
  min-height: 100vh;
  background: #f5f7fb;
}

.el-header {
  padding: 0;
  height: 64px;
  line-height: 64px;
}

.page-main {
  padding: 20px 24px;
  background: #f5f7fb;
}
</style>
